<template>
  <Modal
    cuerpoModal="overflow"
    @closeModal="handleCerrar"
    :showMovilHeader="true"
    :fit="true"
    :showHeader="false"
    :linea="false"
  >
    <Spinner class="position" :clase="false" v-if="loading" />
    <div class="closeModal-container">
      <img
        @click="handleCerrar"
        class="hide-movil"
        src="@/assets/imgs/icons/icono-cerrarModal.svg"
      />
    </div>
    <div class="body-container">
      <p class="title">Crear cita</p>
      <DropdownBusqueda
      v-if="dataCliente?.name ? false : true"
        @id="getClientId"
        :items="clientsCombo"
        @busqueda="handleComboOptions"
        :max-width="true"
        class="input-crearCita"
        placeholder="Buscar cliente"
      />
      <div v-else class="existente-container">
      <div
          placeholder="Nombre"
          class="input"
          type="text"
      >
     {{dataCliente.name}}
        </div>
        <div
          placeholder="Apellido Paterno"
          class="input"
          type="text"
        > 
        {{ dataCliente.first_lastname }}
      </div>
        <div
        v-if="dataCliente?.second_lastname ? true : false"
          placeholder="Apellido Materno"
          class="input"
          type="text"
        > 
        {{ dataCliente.second_lastname }}
      </div>
    </div>
      <!-- <input class="input-crearCita" placeholder="Buscar cliente" v-model="busqueda" /> -->
      <div class="select-container">
        <DropdownDate
          @fecha="getDate"
          id="dropdown"
          :maxWidth="true"
          :minDate="fechaHoy"
          class="select-item"
        />
        <Dropdown
          @status="getItem"
          :items="hourOptions"
          id="dropdown"
          :maxWidth="true"
          class="select-item"
        />
      </div>

      <div class="btn-container">
        <button @click="handleRegistrar" class="btn-registrar">Registrar cliente</button>
        <button
          @click="agendarCita"
          :disabled="disabledAgenda"
          class="btn-agendar"
        >
          Agendar cita
        </button>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "../Modales/Modal.vue";
import Dropdown from "../Dropdowns/Dropdown.vue";
import DropdownDate from "../Dropdowns/DropdownDate.vue";
import DropdownBusqueda from "../Dropdowns/DropdownBusqueda.vue";
import appoinmentsService from "../../services/appoinmentService";
import Spinner from "../Loaders/spinner.vue";
import moment from "moment";
export default {
  components: {
    Modal,
    Dropdown,
    DropdownDate,
    DropdownBusqueda,
    Spinner,
  },
  emits: ["cerrar", "exito", "falla","registrar"],
  props: {
    dataCliente:{
      type:Object
    }
  },
  data() {
    return {
      busqueda: "",
      clientsCombo: [{ value: -1, text: "Busque un cliente" }],
      hourOptions: [
        { value: 9, text: "9:00 AM" },
        { value: 10, text: "10:00 AM" },
        { value: 11, text: "11:00 AM" },
        { value: 12, text: "12:00 PM" },
        { value: 13, text: "01:00 PM" },
        { value: 14, text: "02:00 PM" },
        { value: 15, text: "03:00 PM" },
        { value: 16, text: "04:00 PM" },
        { value: 17, text: "05:00 PM" },
        { value: 18, text: "06:00 PM" },
        { value: 19, text: "07:00 PM" },
      ],
      clientId: "",
      fecha: "",
      hour: "",
      loading: false,
    };
  },
  methods: {
    async handleComboOptions(value = "") {
      this.clientsCombo = { value: -1, text: "...Cargando" };
      const res = await appoinmentsService.getClients(value);
      this.clientsCombo =
        res.length > 0
          ? res
          : [{ value: -1, text: "No se encontraron resultados" }];
    },
    handleRegistrar(){
      this.$emit("registrar")
    },
    async agendarCita() { 
      const data = {
        clienteId: this.clientId,
        fecha: this.fecha,
        hora: this.hour,
      };
      try {
        this.loading = true;
        await appoinmentsService.createAppoinment(data);
        this.loading = false;
        this.$emit("exito", "La cita se creo con éxito");
      } catch (err) {
        this.loading = false;
        console.log(err);
        this.$emit("falla", err.data.message);
      }
    },
    handleCerrar() {
      this.$emit("cerrar");
    },
    getClientId(id) {
      this.clientId = id;
    },
    getItem(hour) {
      this.hour = hour;
    },
    editarStatus() {
      this.$emit("editar", { status: this.status?.status, id: this.status.id });
    },
    getDate(fecha) {
      this.fecha = fecha;
    },
    llenarDatos(){
      if(this.dataCliente?.name){
        this.clientId = this.dataCliente._id
      }
      return
    }
  },
  computed: {
    fechaHoy(){
      return moment().format("YYYY-MM-DD")
    },
    getStatus() {
      switch (this.status?.status) {
        case 0:
          return "cancelar";
        case 1:
          return "pendiente";
        case 2:
          return "no asistio";
        case 3:
          return "asistio";
        default:
          return "pendiente";
      }
    },
    disabledAgenda() {
      if (this.fecha && this.clientId && this.hour) return false;
      return true;
    },
  },
  mounted() {
    this.handleComboOptions();
    this.llenarDatos()
  },
};
</script>

<style scoped>

.input {
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #afafaf;
  border-radius: 4px;
  padding-left: 7px;
  font: normal normal normal 16px/22px Open Sans;
  letter-spacing: 0px;
  color: #616161;
  background: #F7F7F7 0% 0% no-repeat padding-box;
}
.position{
  position: absolute;
  top:0;
  left: 0;
}
.input-crearCita {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 43px;
  height: 40px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 4px;
  background-image: url("../../assets/imgs/Buscar.svg");
  background-size: 17px;
  background-position-y: center;
  background-position-x: 10px;
  outline: none;
  padding-left: 33px;
}
.input-crearCita::placeholder {
  opacity: 0.5;
}
.hide-movil {
  cursor: pointer;
}

.btn-container {
  margin-top: 30px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 20px 30px;
  align-items: center;
}
.btn-registrar {
  width: 172px;
  height: 22px;
  text-align: left;
  font: normal normal bold 16px/22px Open Sans;
  letter-spacing: 0px;
  color: #4caf50;
  cursor: pointer;
}
.btn-agendar {
  width: 172px;
  height: 40px;
  background: #e5fae6 0% 0% no-repeat padding-box;
  border-radius: 4px;
  background-color: #4caf50;
  color: #fff;
  cursor: pointer;
}
.btn-agendar:disabled {
  opacity: 0.5;
  cursor: no-drop;
}
.body-container {
  height: 350px;
  width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* padding: 0 10px; */
}
.img {
  widows: 80px;
  height: 95px;
}

.existente-container{
  width: 100%;
  display: grid;
  grid-template-columns: 100%;
  row-gap: 15px;
  margin-bottom: 15px;
}

.closeModal-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 10px;
}
.closeModal-container img {
  height: 23px;
  width: 23px;
}
.title {
  width: 100%;
  text-align: left;
  font: normal normal bold 20px/27px Open Sans;
  letter-spacing: 0px;
  color: #0a4f9c;
  margin-bottom: 20px;
}

.select-container {
  width: 100%;
  display: grid;
  grid-template-columns: 48.5% 48.5%;
  column-gap: 18px;
}

.select-item {
  justify-self: center;
}

#dropdown {
  width: 100%;
}

@media screen and (max-width: 767px) {
  .title {
    font: normal normal bold 14px/19px Open Sans;
  }
  .body-container {
    width: 100%;
    /* padding: 20px; */
    height: calc(100vh - 60px);
    display: flex;
    flex-direction: column;

  }
  .hide-movil {
    display: none;
  }


.btn-container {
  margin-top: 30px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 20px 10px;
  align-items: center;
  margin-top: 200px;
}
.title {
  margin-top: 50px;
  margin-bottom: 30px;
}


}
</style>
